import type { ValueGetterFunc } from 'ag-grid-community';
import type { HoldingsGridRowData, HoldingsTreeRow } from '../types';

export const holdingsColumnValueGetter: ValueGetterFunc<HoldingsTreeRow | HoldingsGridRowData> = ({ data, colDef }) => {
  const index = Number(colDef.field);
  if (data?.value[index] === 0) {
    // do not display values with zero allocation
    return undefined;
  }

  return data?.value[index];
};
